import PersonalizationDetails from './components/PersonalizationDetails'
import FinancialBreakdown from './components/FinancialBreakdown'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import ApiService from '../../data/services/ApiService'
import Moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import Barcode from 'react-barcode'
import { Row, Col, Button } from 'reactstrap'

const Print = (props) => {
    const [order, setOrder] = useState()
    const [lineItems, setLineItems] = useState([])

    useEffect(() => {
        (async () => {
            const id = props.match.params.id
            await fetchOrderById(id)
        })()
    }, []) // eslint-disable-line

    const fetchOrderById = async (id) => {
        try {
            const response = await ApiService.getSalesOrderForPrintById(id)

            setOrder(response.data.sale)
            setLineItems(response.data.sale.lineItems)
        } catch (error) {
            // 
        }
    }


    return (
        <React.Fragment>
            {order && (
                <React.Fragment>
                    <div className="order-action-bar">
                        <Row>
                            <Col sm={6}>
                                <h1>O-{order.folio}</h1>
                            </Col>
                            <Col sm={6} style={{ textAlign: 'right' }}>
                                <Button color='default'
                                    onClick={() => { window.close() }}>
                                    <i className='mdi mdi-close'></i> Cerrar
                                </Button>
                                <Button color='primary'
                                    onClick={() => { window.print() }}>
                                    <i className='mdi mdi-printer'></i> Imprimir
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <div className="order page">
                        <Row className='order-header'>
                            <Col sm={7}>
                                <img width={128} alt="Canvas Express" src="/assets/images/logo.png" />
                            </Col>

                            <Col sm={5} style={{ textAlign: 'right' }}>                                
                                <div className="barcode-wrapper">
                                    <Barcode width={3} height={24} lineColor={'#495057'} displayValue={false} value={order.folio} />
                                </div>

                                <Row>
                                    <Col sm={6}><strong>Pedido</strong></Col>
                                    <Col sm={6}>O-{order.folio}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><strong>Fecha</strong></Col>
                                    <Col sm={6}>{Moment(order.createdAt).format("DD/MM/YYYY")}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><strong>Cliente</strong></Col>
                                    <Col sm={6}>{order.user?.fullName || order.customerSnapshot?.fullName || 'No registrado'}</Col>
                                </Row>
                                <Row>
                                    <Col sm={6}><strong>Status</strong></Col>
                                    <Col sm={6}>{order.status}</Col>
                                </Row>
                            </Col>
                        </Row>

                        <section className="items">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Imagen</th>
                                        <th>Producto</th>
                                        <th>CANT</th>
                                        <th>Precio unitario antes de descuentos</th>
                                        <th>Importe antes de descuentos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lineItems.map((item, i) => (
                                        <tr key={i}>
                                            <td>
                                                <img src={item.productImage} width={64} alt="" />
                                            </td>
                                            <td>
                                                <strong>{item.productName || item.variant?.name || 'Personalizado'}</strong><br />
                                                {item.variant?.sku && <small>SKU: {item.variant.sku}</small>}
                                                {item.categoryType === 'ARTIST' && (
                                                    <React.Fragment>
                                                        <br />
                                                        <small>
                                                            <strong>Artista invitado:</strong> {item.artistName}<br />
                                                            <strong>Colección:</strong> {item.collectionName}
                                                        </small>
                                                    </React.Fragment>
                                                )}
                                                {<PersonalizationDetails item={item} />}
                                            </td>
                                            <td>{item.quantity}</td>
                                            <td><CurrencyFormat decimalScale={2} displayType="text" thousandSeparator prefix="$" value={item.unitPrice} /></td>
                                            <td><CurrencyFormat decimalScale={2} displayType="text" thousandSeparator prefix="$" value={item.unitPrice * item.quantity} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={3}>
                                            <strong>Notas</strong><br />

                                            {order.message}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <FinancialBreakdown order={order} />
                        </section>
                    </div>
                    <div className="order-footer-bar">
                        <p>Hecho con <span role="img" aria-label='heart'>♥️</span> por juvasoft</p>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default withRouter(Print)
